export const FilespaceCardTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getFilespaceCardBase: () => 'filespace-card',
    getFilespaceCardStatusBase: () => [FilespaceCardTestIdFactory.getFilespaceCardBase(), 'status'].join('-'),
    getFilespaceCardMigrationBase: () => [FilespaceCardTestIdFactory.getFilespaceCardBase(), 'migration'].join('-'),
    getFilespaceCardStatusIconBase: () => [FilespaceCardTestIdFactory.getFilespaceCardStatusBase(), 'icon'].join('-'),
    getFilespaceCardUpgradeIconBase: () => [
        FilespaceCardTestIdFactory.getFilespaceCardMigrationBase(),
        'icon',
    ].join('-'),
    getFilespaceCardStatusImageBase: () => [FilespaceCardTestIdFactory.getFilespaceCardStatusBase(), 'image'].join('-'),
    getFilespaceCardDetailsBase: () => [FilespaceCardTestIdFactory.getFilespaceCardBase(), 'details'].join('-'),
    getFilespaceCardDetailsStatusBase: () => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsBase(),
        'status',
    ].join('-'),
    getFilespaceCardDetailsStatusTextBase: () => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsStatusBase(),
        'text',
    ].join('-'),
    getFilespaceCardDetailsNameBase: () => [FilespaceCardTestIdFactory.getFilespaceCardDetailsBase(), 'name'].join('-'),
    getFilespaceCardDetailsNameTextBase: () => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsNameBase(),
        'paragraph-text',
    ].join('-'),
    // for test id generation
    getFilespaceCardTestId: (testId) => [FilespaceCardTestIdFactory.getFilespaceCardBase(), testId].join('-'),
    getFilespaceCardStatusIconTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardStatusIconBase(),
        testId,
    ].join('-'),
    getFilespaceCardUpgradeIconTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardUpgradeIconBase(),
        testId,
    ].join('-'),
    getFilespaceCardStatusImageTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardStatusImageBase(),
        testId,
    ].join('-'),
    getFilespaceCardDetailsTestId: (testId) => [FilespaceCardTestIdFactory.getFilespaceCardDetailsBase(), testId].join('-'),
    getFilespaceCardDetailsStatusTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsStatusBase(),
        testId,
    ].join('-'),
    getFilespaceCardDetailsStatusTextTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsStatusTextBase(),
        testId,
    ].join('-'),
    getFilespaceCardDetailsNameTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsNameBase(),
        testId,
    ].join('-'),
    getFilespaceCardDetailsNameTextTestId: (testId) => [
        FilespaceCardTestIdFactory.getFilespaceCardDetailsNameTextBase(),
        testId,
    ].join('-'),
};
